const CARD_FRONT_LABELS = Object.freeze({
  toivos: "Toivos deck",
  jp: "JP Custom",
  emoji: "Simple Emoji",
  utf8: "UTF-8 custom"
});

export { CARD_FRONT_LABELS };

export function normalizeCardFrontStyle(value) {
  return Object.prototype.hasOwnProperty.call(CARD_FRONT_LABELS, value) ? value : "toivos";
}
